import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "homeReport";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //主页报表---头部统计数据
    async GetHomeCountData({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingHomeReport/Home?year=${payload}`
      );
      return result;
    },
    //主页报表--饼状图按产品汇总
    async GetReportByProduct({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingSaleReport/GetGroupByProduct?${queryString.stringify(
          payload
        )}`
      );
      return result;
    },
    //主页报表--饼状图客户汇总
    async GetReportByDealer({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingSaleReport/GetGroupByDealer?${queryString.stringify(
          payload
        )}`
      );
      return result;
    },
    //主页报表--饼状图按销售员汇总
    async GetReportBySaler({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingSaleReport/GetGroupBySaler?${queryString.stringify(
          payload
        )}`
      );
      return result;
    },
    //主页报表--柱状图
    async GetBarReport({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingHomeReport/Amount?${queryString.stringify(payload)}`
      );
      return result;
    },
    // 产品分类
    async getFishType({ commit }, payload) {
      var result = await api.get(
        `/api/WeighingSaleReport/ProductCategorys?mode=${payload}`
      );
      return result.data;
    },
    // 仓库
    async getWarehouse({ commit }, payload) {
      var result = await api.get(
        `/api/WeighingSaleReport/Warehouses?mode=${payload}`
      );
      return result.data;
    },
  },
});

export default moduleName;
